export interface UseScrollLock {
  lock: () => void
  unlock: () => void
}

let lockCount = 0
let previousBodyOverflow = ''

export function useScrollLock(): UseScrollLock {
  function lock(): void {
    if (typeof document === 'undefined') return
    if (lockCount === 0) {
      previousBodyOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
    }
    lockCount += 1
  }

  function unlock(): void {
    if (typeof document === 'undefined') return
    if (lockCount === 0) return
    lockCount -= 1
    if (lockCount === 0) {
      document.body.style.overflow = previousBodyOverflow
    }
  }

  return { lock, unlock }
}
